// src/components/Gallery/Gallery.js - Poboljšana verzija
import React, { useState } from "react";
import { Carousel } from "react-bootstrap";
import facePainting2 from "../../assets/img/face-painting.jpg";
import elephant from "../../assets/img/elephant.jpg";
import kidsWorks from "../../assets/img/kids-works.JPG";
import beansPainting2 from "../../assets/img/beans-painting-2.JPG";
import "./Gallery.css";

function Gallery() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const images = [
    {
      src: facePainting2,
      title: "Face painting",
      caption: "Profesionalno šminkanje lica",
      alt: "Dijete sa profesionalnom šminkom lica - face painting primjer Baby Zoo Garden radionice",
    },
    {
      src: elephant,
      title: "Elephant art",
      caption: "Kreativne životinjske šminke",
      alt: "Kreativna šminka slona na dječjem licu - primjer umjetničkog face paintinga",
    },
    {
      src: kidsWorks,
      title: "Kids works",
      caption: "Radovi naše djece",
      alt: "Izložba dječjih umjetničkih radova sa kreativnih radionica Baby Zoo Garden",
    },
    {
      src: beansPainting2,
      title: "Beans painting",
      caption: "Slikanje i kreativnost",
      alt: "Djeca slikaju koristeći pasulj i prirodne materijale - kreativna radionica",
    },
  ];

  const handleSelect = (selectedIndex) => {
    setCurrentIndex(selectedIndex);
  };

  return (
    <section
      className="gallery"
      id="gallery"
      aria-label="Galerija slika sa radionica"
    >
      <div className="container">
        <h2 className="section-title">Galerija</h2>

        <div
          className="gallery-slider"
          role="region"
          aria-roledescription="carousel"
          aria-label="Foto galerija Baby Zoo Garden aktivnosti"
        >
          <Carousel
            interval={3000}
            pause="hover"
            activeIndex={currentIndex}
            onSelect={handleSelect}
            indicators={true}
            controls={true}
          >
            {images.map((image, index) => (
              <Carousel.Item key={index}>
                <div className="carousel-image-wrapper">
                  <img
                    className="d-block carousel-image"
                    src={image.src}
                    alt={image.alt}
                    loading={index === 0 ? "eager" : "lazy"}
                  />
                </div>
                <Carousel.Caption className="custom-caption">
                  <h3>{image.title}</h3>
                  <p>{image.caption}</p>
                </Carousel.Caption>
              </Carousel.Item>
            ))}
          </Carousel>

          {/* Screen reader opis trenutne pozicije */}
          <div
            className="visually-hidden"
            aria-live="polite"
            aria-atomic="true"
          >
            Slika {currentIndex + 1} od {images.length}:{" "}
            {images[currentIndex].title}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Gallery;
